export default __webpack_public_path__ + "static/media/fig-18-shear-drop-shaft.11348795.png";